module.exports = __webpack_public_path__ + "static/media/LI_Logo.f08c524d.png";